import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";

Vue.config.productionTip = false;
Vue.filter("formatDate", function(value, format) {
  if (value) {
    return moment(String(value))
      .format(format)
      .toUpperCase();
  }
  //return value == "" ? "": value.toString().length > 10 ? value.toISOString().slice(0, 10): value;
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
